import { RouteObject } from 'react-router-dom';
import { loader as claimOverviewLoader } from '~/app/features/crew/claim-overview/claimOverview';
import ClaimOverviewPage from '~/app/features/crew/claim-overview/ClaimOverviewPage';
import InactiveMerchantPage from '~/app/features/inactive-merchant/InactiveMerchantPage';
import {
  crewOrderLookupAction,
  crewOrderLookupLoader,
} from '~/app/features/order-lookup/orderLookup';
import { BrandedOrderLookupPage } from '~/app/features/order-lookup/OrderLookupPage';
import {
  action as customerInfoAction,
  loader as customerInfoLoader,
} from '~/app/features/registrations/customer-info/customerInfo';
import CustomerInfoPage from '~/app/features/registrations/customer-info/CustomerInfoPage';
import { loader as registrationLoader } from '~/app/features/registrations/registration-overview/registrationOverview';
import RegistrationOverviewPage from '~/app/features/registrations/registration-overview/RegistrationOverviewPage';
import {
  action as selectProductsAction,
  loader as selectProductsLoader,
} from '~/app/features/registrations/select-products/selectProducts';
import SelectProductsPage from '~/app/features/registrations/select-products/SelectProductsPage';
import {
  catchallRoute,
  makeRegistrationLoader,
  redirect,
} from '~/utils/routing';
import Order from './order';

export default {
  path: '/:store',
  children: [
    {
      id: 'crewOrderLookup',
      index: true,
      action: crewOrderLookupAction,
      loader: crewOrderLookupLoader,
      Component: BrandedOrderLookupPage,
    },
    Order,
    {
      id: 'inactiveMerchant',
      path: 'inactive',
      Component: InactiveMerchantPage,
    },
    {
      id: 'claimOverview',
      path: 'claim/overview/:claimExternalId',
      Component: ClaimOverviewPage,
      loader: claimOverviewLoader,
    },
    {
      id: 'register',
      path: 'register',
      loader: makeRegistrationLoader(({ context, params }) =>
        context.settings.registrations.isEnabled ?
          {
            ok: true,
          }
        : redirect(`/${params.store ?? ''}`),
      ).loader,
      children: [
        {
          id: 'customerInfo',
          action: customerInfoAction,
          loader: customerInfoLoader,
          Component: CustomerInfoPage,
          index: true,
        },
        {
          id: 'selectProducts',
          path: 'product',
          action: selectProductsAction,
          loader: selectProductsLoader,
          Component: SelectProductsPage,
        },
        {
          id: 'registrationOverview',
          path: 'overview',
          Component: RegistrationOverviewPage,
          loader: registrationLoader,
        },
      ],
    },
    catchallRoute,
  ],
} satisfies RouteObject;
